import React from 'react'
import '../styles/prints.css'
import MainImage from '../assets/images/353-copy-3-2048x1099.jpg'
import PrintCard from '../components/PrintCard/PrintCard'
import Helmet from '../components/Helmet/Helmet';

import card1 from '../assets/images/tigerOntree.jpg'
import card2 from '../assets/images/tigerPrint.jpg'
import card3 from '../assets/images/roar.jpg'
import card4 from '../assets/images/prince.jpg'
import card5 from '../assets/images/kuruttu.jpg'

const Prints = () => {
  return<Helmet title={'Prints'}>
  <section className='prints__main'>
    <div className="w-1">
        <h1 className='__h1' >Prints</h1>
        <span className='dash'></span>
        <img src={MainImage} alt="" />
    </div>
    <div className="w-1 print__card-items fsb">
        <PrintCard
            to='/product/perfect-view-comfort-rating'
            imgSrc={card1}
            link="Add to cart The view is a 10/10. The comfort is 1000/10"
            style={{width:'49%'}}
            // imgStyle={{height:'750px'}}
        />
        <PrintCard
            to='/product/the-perfect-amount-of-sunkissed'
            imgSrc={card2}
            link="The perfect amount of Sunkissed"
            style={{width:'49%'}}
            // imgStyle={{height:'750px'}}
        />
    </div>
    <div className="w-1 fsb print__card-items">
        <PrintCard
            to='/product/tell-the-wild-im-home'
            imgSrc={card3}
            link="Add to cart Tell the wild. I’m home"
            style={{width:'32%'}}
            // imgStyle={{height:'500px'}}
        />
        <PrintCard
            to='/product/hunt-goals-not-set'
            imgSrc={card4}
            link="I don’t set goals. I hunt them down"
            style={{width:'32%'}}
            // imgStyle={{height:'500px'}}
        />
        <PrintCard
            to='/product/brave-fearless-bold-strong'
            imgSrc={card5}
            link="I am Brave , Fearless , Bold & Strong"
            style={{width:'32%'}}
            // imgStyle={{height:'500px'}}
        />
    </div>
  </section>
  </Helmet> 
}

export default Prints